import './index.scss';
import React from 'react';
import { isInApp, isInMobile } from '@umu/umu-ua';
import { Iconfont, Tooltip, Modal } from '@umu/umu-design';
import { lang } from '@umu/ukit-lang';
import { TooltipPlacement, TooltipProps } from '@umu/umu-design/es/components/Tooltip';
export type ITitleConfig = JSX.Element | string | string[];

interface IIconToolTipProps {
    title: ITitleConfig;
    prefix?: ITitleConfig;
    suffix?: ITitleConfig;
    iconType?: string;
    className?: string;
    zIndex?: number;
    placement?: TooltipPlacement;
    tipsDialogOkText?: string;
    tooltipProps?: TooltipProps & React.RefAttributes<unknown>;
}
const { confirm } = Modal;
// tooltip 弹窗额外样式
const overlayInnerStyle = {
    lineHeight: '0.2rem',
    color: '#111010',
    fontSize: '0.14rem',
};
/**
 * @param 获取tips信息
 */
const getCardTooltipDesc = (desc: ITitleConfig, cls = 'custom-icon-tooltip-list') => {
    if (Array.isArray(desc)) {
        return desc.map((item, index) => {
            return (
                <p key={`card-tooltip-desc-${index}`} className={cls}>
                    {item}
                </p>
            );
        });
    }
    return desc;
};
const onIconToolTip = (info: IIconToolTipProps) => {
    const {
        title,
        prefix,
        suffix,
        iconType = 'tips',
        placement = 'bottom',
        className = '',
        tipsDialogOkText,
        tooltipProps,
    } = info;
    const isDialogTips = isInApp() || isInMobile();
    const tipsTitle = getCardTooltipDesc(title);
    const onIconTipsClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        confirm({
            title: prefix || '',
            centered: true,
            content: tipsTitle,
            okText: tipsDialogOkText || lang('知道了'),
            okType: 'text',
        } as any);
    };
    return (
        <div className={`custom-icon-tooltip-desc ${className}`}>
            {prefix}
            {isDialogTips ? (
                <Iconfont type={iconType} className="tips-ems-icon" onClick={onIconTipsClick} />
            ) : (
                <Tooltip
                    title={tipsTitle}
                    placement={placement}
                    hideArrow
                    color="#ffffff"
                    zIndex={info.zIndex}
                    overlayInnerStyle={{ ...overlayInnerStyle, width: 300 }}
                    {...tooltipProps}
                >
                    <Iconfont type={iconType} className="tips-ems-icon" />
                </Tooltip>
            )}
            {suffix && <div className="rate-tooltip-suffix">{suffix}</div>}
        </div>
    );
};
export { overlayInnerStyle, getCardTooltipDesc, onIconToolTip };
